import { Component,ViewChild,HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, pipe } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

import { MailService } from '../contact/mail.service';
import { MailRequestInfoModel } from '../../shared/email/mail-request-info-model';
import { SendEmailResponse } from '../../shared/email/send-email-response';
import { MailStatusModel } from '../../shared/email/mail-status-model';
import { ComponentLogoutCanDeactivate } from '../../CanLogoutDeactivateGaurd'
import { NgForm } from "@angular/forms";

@Component({
  selector: "homeC3POR3",
  templateUrl: "./home.componentC3POR3.html",
  styleUrls: ['./home.componentC3POR3.scss']
})
export class HomeComponentC3POR3   {
  @ViewChild('form')
  form: NgForm;
  successMessage: string = "";
  errorMessage: string = "";

  public mailService: MailService;
  mailRequest: MailRequestInfoModel;

  //@HostListener('window:beforeunload')
  //canDeactivate(): Observable<boolean> | boolean {
  //  let pagecount = JSON.parse(localStorage.getItem('pagecount'));
  //  pagecount = pagecount - 2;
  // // alert('home deactivate ' + window.history.length)
  //  //if (pagecount == 2 || pagecount == 1) {
  //  //  localStorage.removeItem('currentUser');     
  //  //}
  //  return true;
  //  // insert logic to check if there are pending changes here;
  //  // returning true will navigate without confirmation
  //  // returning false will show a confirm dialog before navigating away
  //}

  constructor(private router: Router, _mailService: MailService) {
   // super();
    this.mailService = _mailService;
    this.mailRequest = new MailRequestInfoModel;

    this.errorMessage = "";
    this.successMessage = "";
  }

  contactSend() {
    this.errorMessage = "";
    this.successMessage = "";
    let reg = new RegExp(this.mailService.emailPattern);

    if (this.mailRequest.body.length > 0 && this.mailRequest.contactname.length > 0 && this.mailRequest.contactemail.length > 0 && reg.test(this.mailRequest.contactemail)) {
      this.mailRequest.subject = "C3PO-R3 : Contact Form Submission";
      this.mailService.SendEmail(this.mailRequest).subscribe(data => this.validateSend(data));
    } else {
      if (this.mailRequest.body.length === 0) {
        this.errorMessage = "Message is required";
      }

      if (this.errorMessage.length > 0) {
        this.errorMessage = this.errorMessage + "<br/>";
      }

      if (this.mailRequest.contactname.length === 0) {
        this.errorMessage = "Name is required";
      }

      if (this.errorMessage.length > 0) {
        this.errorMessage = this.errorMessage + "<br/>";
      }

      if (this.mailRequest.contactemail.length === 0) {
        this.errorMessage = this.errorMessage + "Email is required";
      } else if (!reg.test(this.mailRequest.contactemail)) {
        this.errorMessage = this.errorMessage + "Email is not a valid format";
      }
    }
  }

  validateSend(data: SendEmailResponse) {
    if (data.DataObject.status == "Mail Sent") {
      this.mailRequest = new MailRequestInfoModel;
      this.successMessage = "Message Sent"
    } else {
      this.errorMessage = data.DataObject.failreason;
    }
  }

  ngOnInit() {
    //let pagecount = JSON.parse(localStorage.getItem('pagecount'));
    //pagecount++;
    ////alert('home init ' + pagecount)
    //localStorage.setItem('pagecount', pagecount);
  }

  ngOnDestroy() {
    //let pagecount = JSON.parse(localStorage.getItem('pagecount'));
    //pagecount--;
    //alert('home destroy ' + pagecount)

    //localStorage.setItem('pagecount', pagecount);
  }
}
